import React, { useMemo } from 'react';
import moment from 'moment';
import _ from 'lodash';
import { Table, Button } from 'antd';
import { useGetEnochProfileDetails } from 'query/enoch';
import { useEnochFilterContext } from './context';
import { mapIpToMachineName } from './common';

const { Column } = Table;

export default function EnochProfileConnectionDetails() {
  const filter = useEnochFilterContext();

  const {
    isFetching,
    data,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
  } = useGetEnochProfileDetails(filter);

  const renderData = useMemo(() => {
    let result = [];
    if (data) {
      result = _.flatten(data.pages.map(({ data: reports }) => reports));
    }
    return result;
  }, [data]);

  return (
    <Table
      dataSource={renderData}
      footer={() => {
        if (!hasNextPage) return null;
        return (
          <div className="flex" style={{ justifyContent: 'center' }}>
            <Button
              loading={isFetchingNextPage}
              onClick={() => fetchNextPage()}
            >
              {isFetchingNextPage ? 'Loading More...' : 'More Items'}
            </Button>
          </div>
        );
      }}
      loading={isFetching && !isFetchingNextPage}
      pagination={false}
      scroll={{ x: true }}
      size="small"
    >
      <Column dataIndex="email" fixed="left" key="email" title="Email" />
      <Column dataIndex="profile" key="profile" title="Profile" />
      <Column
        dataIndex="ipAddress"
        key="ipAddress"
        render={ip => mapIpToMachineName[ip] || ip}
        title="Machine IP"
      />
      <Column
        dataIndex="disconnectReason"
        key="disconnectReason"
        title="Reason"
      />
      <Column
        dataIndex="updatedAt"
        key="updatedAt"
        render={text => {
          return moment(text).format('YYYY-MM-DD');
        }}
        title="Disconnected At"
      />
    </Table>
  );
}
